import React from 'react';
import TypeChips from './components/TypeChips';
import RangeSliderWithInputs from './components/RangeSliderWithInputs';
import LocationPicker from './components/LocationPicker';

const STRATEGIES = [
    { value: 'flip', label: 'Flip' },
    { value: 'rental', label: 'Rental Yield' },
    { value: 'long_term', label: 'Long Term' }
];

export default function IntentInvestForm({ data, onChange }) {
    const updateBasics = (field, value) => onChange('basics', field, value);
    const updateBudget = (field, value) => onChange('budget', field, value);
    const updateSpecs = (field, value) => onChange('specifications', field, value);

    const { basics = {}, budget = {}, specifications = {} } = data;

    return (
        <div className="req-grid">
            <div className="req-col-span-2">
                <h3 className="req-section-title">Investment Thesis</h3>
            </div>

            <div className="req-field req-col-span-2">
                <label className="req-label">Strategy</label>
                <TypeChips
                    options={STRATEGIES}
                    value={specifications.strategies || []}
                    onChange={(val) => updateSpecs('strategies', val)}
                />
            </div>

            <div className="req-col-span-2">
                <LocationPicker
                    city={basics.city}
                    localities={basics.localities}
                    onChange={updateBasics}
                />
            </div>

            <div className="req-field req-col-span-2">
                <label className="req-label">Pincode</label>
                <input
                    type="text"
                    className="req-input"
                    placeholder="e.g. 560001"
                    value={basics.pincode || ''}
                    onChange={(e) => updateBasics('pincode', e.target.value)}
                />
            </div>

            <RangeSliderWithInputs
                label="Investment Amount"
                valueMin={budget.min}
                valueMax={budget.max}
                onChange={({ min, max }) => {
                    updateBudget('min', min);
                    updateBudget('max', max);
                }}
            />

            <div className="req-field">
                <label className="req-label">Horizon</label>
                <select
                    className="req-input"
                    value={specifications.horizon || '3-5y'}
                    onChange={(e) => updateSpecs('horizon', e.target.value)}
                >
                    <option value="<1y">&lt; 1 Year</option>
                    <option value="1-3y">1-3 Years</option>
                    <option value="3-5y">3-5 Years</option>
                    <option value="5y+">5+ Years</option>
                </select>
            </div>
        </div>
    );
}
